import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController, Platform, LoadingController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { DashboardPage } from '../dashboard/dashboard';
import { ImagePicker} from '@ionic-native/image-picker';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment'
moment.locale('es')

/**
 * Generated class for the CobroPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-cobro',
  templateUrl: 'cobro.html',
})
export class CobroPage {
  clientes: any = []
  vendedores: any = []
  vendedor: any
  facturas: any = []
  selectOptionsTipo: any = {
    title: 'Tipo',
  }
  selectOptionsCliente: any = {
    title: 'Clientes',
  }
  selectOptionsPago: any = {
    title: 'Metodo de Pago',
  }
  selectOptionsRecibe: any = {
    title: '¿Quién recibe?',
  }
  police = false
  imageURI: any = ""
  imageURI2: any = ""
  cajaAsignada: any = ""
  cobro: any = {
    titular: null,
    vendedor: '',
    cliente: null,
    facturas: [],
    monto: null,
    referencia: '',
    descripcion: '',
    bauche: '',
    bauche2: '',
    metodo: '',
    tasa: null,
    fechaP: moment().hours(0).minutes(0).seconds(0).format("YYYY-MM-DDTHH:mm"),
    estatus: "Pendiente"
  }
  metodos: any = []
  bauche2: any = []
  deuda = 0;
  super: any = false
  co_ven: any
  loadModal: any
  constructor(
    public navCtrl: NavController,
    private transfer: FileTransfer, 
    private camera: Camera, 
    public platform: Platform,
    public navParams: NavParams,
    public imagePicker : ImagePicker, 
    public loadingCtrl: LoadingController,
    public sanitazer : DomSanitizer,
    public http: HttpProvider,
    public modal: ModalController,
    public alertCrtl: AlertController
    ) {
    this.cajaAsignada = window.localStorage.getItem('cajaAsignada')
    if(window.localStorage.getItem('network') === '1') {
      if(window.localStorage.getItem('super')) {
        this.super = true
        this.ActivarLoading()
        this.http.get(`metodopago`).subscribe(
          (res: any) => {
            this.metodos = res
          },
          err => {
            console.log(err)
          }
        )
        this.http.get(`vendedor/supSinDeuda?vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
          (res: any) => {
            this.DesactivarLoading()
            this.vendedores = res
          },
          err => {
            this.DesactivarLoading()
            console.log(err)
          }
          )
      } else {
        this.co_ven = window.localStorage.getItem('co_ven')
        this.ActivarLoading()
        this.http.get(`metodopago`).subscribe(
          (res: any) => {
            this.metodos = res
          },
          err => {
            console.log(err)
          }
        )
        this.http.get(`cliente/venD/${this.co_ven}`).subscribe(
          (res: any) => {
            this.DesactivarLoading()
            this.clientes = res
          },
          err => {
            this.DesactivarLoading()
            console.log(err)
          }
        )
      }
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }

  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  verificarMoneda() {
    let bool = false;
    this.metodos.forEach(el=>{
      if (el._id.toString() == this.cobro.metodo.toString() && el.moneda == "BSD") bool = true
    })
    return bool
  }

  buscarCli() {
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.get(`cliente/venD/${this.vendedor.co_ven}`).subscribe(
        (res: any) => {
          this.DesactivarLoading()
          this.clientes = res
        },
        err => {
          this.DesactivarLoading()
          console.log(err)
        }
      )
    }
  }

  buscarFact() {
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.get(`factura/select?cliente=${this.cobro.cliente.co_cli}`).subscribe(
        (res: any) => {
          this.facturas = res
          console.log(this.facturas)
          this.DesactivarLoading()
        },
        err => {
          this.DesactivarLoading()
          console.log(err)
        }
      )
    }
  }

  limpiar() {
    this.cobro.titular = null
    this.cobro.vendedor = ''
    this.cobro.cliente = null
    this.cobro.facturas = []
    this.cobro.monto = null
    this.cobro.descripcion = ''
    this.cobro.tasa = null
    this.cobro.bauche = ''
    this.cobro.bauche2 = ''
    this.cobro.fechaP = moment().hours(0).minutes(0).seconds(0).format("YYYY-MM-DDTHH:mm")
    this.imageURI = ''
    this.imageURI2 = ''
    this.facturas = []
  }

  showConfirm(item) {
    const confirm = this.alertCrtl.create({
      title: 'Seleccione',
      buttons: [
        {
          text: 'Galería',
          cssClass:'btn',
          handler: () => {
            this.getImage('g', item)
          }
        },
        {
          text: 'Camara',
          cssClass:'btn',
          handler: () => {
            this.getImage('c', item)
          }
        },
        {
          text: 'Salir',
          cssClass:'btnAceptar',
          handler: () => {
          }
        }
      ]
    });
    confirm.present();
  }

  borrar() {
    this.imageURI = ""
    this.cobro.bauche = ""
  }

  borrar2() {
    this.imageURI2 = ""
    this.cobro.bauche2 = ""
  }

  getImage(item, tiipe) {
    this.imagePicker.hasReadPermission().then(res=>{
      if (res) {
        if (item === "g") {
          let optionsImg: CameraOptions = {
            quality:100,
            destinationType: this.camera.DestinationType.FILE_URI,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            sourceType: this.camera.PictureSourceType.SAVEDPHOTOALBUM,
            allowEdit: false
          }
          this.camera.getPicture(optionsImg).then(
            res=>{
              if(this.platform.is('android')){
                if (tiipe) {
                  this.imageURI = (<any>window).Ionic.WebView.convertFileSrc(res)
                } else this.imageURI2 = (<any>window).Ionic.WebView.convertFileSrc(res)
              }else{
                if (tiipe) {
                  this.imageURI = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                } else this.imageURI2 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
              }
              if (tiipe) {
                this.cobro.bauche = res
              } else this.cobro.bauche2 = res
              this.police = true
            },
            error=>console.log(error)
          )
        }
        if (item === "c") {
          let optionsImg: CameraOptions = {
            quality:100,
            destinationType: this.camera.DestinationType.FILE_URI,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            sourceType: this.camera.PictureSourceType.CAMERA,
            allowEdit: false
          }
          this.camera.getPicture(optionsImg).then(
            res=>{
              if(this.platform.is('android')){
                if (tiipe) {
                  this.imageURI = (<any>window).Ionic.WebView.convertFileSrc(res)
                } else this.imageURI2 = (<any>window).Ionic.WebView.convertFileSrc(res)
              }else{
                if (tiipe) {
                  this.imageURI = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                } else this.imageURI2 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
              }
              if (tiipe) {
                this.cobro.bauche = res
              } else this.cobro.bauche2 = res
              this.police = true
            },
            error=>console.log(error)
          )
        }
      } else {
        this.imagePicker.requestReadPermission()
      }
    }).catch(err=>{
      this.alertCrtl.create({
        title:'Atención',
        subTitle:err,
        buttons:[{
          cssClass:'btnAceptar',
          text:'Aceptar'
        }]
      }).present()
    })
  }

  validar() {
    if (this.cobro.metodo === "Efectivo") {
      if (this.cobro.cliente && this.cobro.descripcion && this.cobro.monto && this.cobro.facturas && this.cobro.facturas.length > 0) {
        if (this.super) {
          if (this.vendedor && this.vendedor.co_ven) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return false
      }
    } else if (this.cobro.metodo) {
      if (this.cobro.cliente && this.cobro.descripcion && this.cobro.monto && this.cobro.titular && this.cobro.referencia && this.cobro.facturas && this.cobro.facturas.length > 0) {
        if (this.super) {
          if (this.vendedor && this.vendedor.co_ven) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return false
      }
    } else {
      return false
    }
  }

  async registrar(){
    if(window.localStorage.getItem('network') === '1') {
      if(this.validar()) {
          if (this.super) {
            this.cobro.vendedor = this.vendedor.co_ven
          } else this.cobro.vendedor = this.co_ven
          this.ActivarLoading()
          if (this.police) {
            const fileTransfer: FileTransferObject = this.transfer.create();
            let options: FileUploadOptions = {
              httpMethod: 'POST',
              params: this.cobro,
              fileKey: 'file',
              headers: {}
            }
            await fileTransfer.upload(this.cobro.bauche, this.http.path + 'cobros', options)
            .then(async (res:any) => {
              // success
              if (res && res.response && this.cobro.bauche2) {
                let options2: FileUploadOptions = {
                  httpMethod: 'PUT',
                  params: JSON.parse(res.response),
                  fileKey: 'file',
                  headers: {}
                }
                await fileTransfer.upload(this.cobro.bauche2, this.http.path + 'cobros/bauche2', options2)
                .then((res2:any) => {
                  this.cobro = {
                    titular: null,
                    vendedor: '',
                    cliente: null,
                    facturas: [],
                    monto: null,
                    descripcion: '',
                    bauche: '',
                    bauche2: '',
                    metodo: '',
                    fechaP: moment().hours(0).minutes(0).seconds(0).format("YYYY-MM-DDTHH:mm"),
                    estatus: "Pendiente"
                  }
                  this.DesactivarLoading()
                  this.alertCrtl.create({
                    title:'Información',
                    subTitle:'El cobro ha sido registrado exitosamente',
                    buttons:[
                      {
                        cssClass:'btn',
                        text:'Ir a cobros',
                        handler:()=>{
                          this.navCtrl.pop()
                        }
                      },
                      {
                        cssClass:'btnAceptar',
                        text:'Ir a Inicio',
                        handler:()=>{
                          this.navCtrl.setRoot(DashboardPage)
                        }
                      }
                    ]
                  }).present()
                }, (err2) => {
                  // error
                  this.alertCrtl.create({
                    title:'Atención',
                    subTitle:'Ha ocurrido un error (2)',
                    buttons:[{
                      cssClass:'btnAceptar',
                      text:'Aceptar'
                    }]
                  }).present()
                  this.DesactivarLoading()
                  console.log(err2)
                })
              } else {
                this.cobro = {
                  titular: null,
                  vendedor: '',
                  cliente: null,
                  facturas: [],
                  monto: null,
                  descripcion: '',
                  bauche: '',
                  bauche2: '',
                  metodo: '',
                  fechaP: moment().hours(0).minutes(0).seconds(0).format("YYYY-MM-DDTHH:mm"),
                  estatus: "Pendiente"
                }
                this.DesactivarLoading()
                this.alertCrtl.create({
                  title:'Información',
                  subTitle:'El cobro ha sido registrado exitosamente',
                  buttons:[
                    {
                      cssClass:'btn',
                      text:'Ir a cobros',
                      handler:()=>{
                        this.navCtrl.pop()
                      }
                    },
                    {
                      cssClass:'btnAceptar',
                      text:'Ir a Inicio',
                      handler:()=>{
                        this.navCtrl.setRoot(DashboardPage)
                      }
                    }
                  ]
                }).present()
              }
            }, (err) => {
              // error
              this.alertCrtl.create({
                title:'Atención',
                subTitle:'Ha ocurrido un error',
                buttons:[{
                  cssClass:'btnAceptar',
                  text:'Aceptar'
                }]
              }).present()
              this.DesactivarLoading()
              console.log(err)
            })
          } else {
            this.http.post('cobros', this.cobro).subscribe(
              (res:any) => {
                this.cobro = {
                  titular: null,
                  vendedor: '',
                  cliente: null,
                  facturas: [],
                  monto: null,
                  descripcion: '',
                  bauche: '',
                  bauche2: '',
                  metodo: '',
                  fechaP: moment().hours(0).minutes(0).seconds(0).format("YYYY-MM-DDTHH:mm"),
                  estatus: "Pendiente"
                }
                this.DesactivarLoading()
                this.alertCrtl.create({
                  title:'Información',
                  subTitle:'El cobro ha sido registrado exitosamente',
                  buttons:[
                    {
                      cssClass:'btn',
                      text:'Ir a cobros',
                      handler:()=>{
                        this.navCtrl.pop()
                      }
                    },
                    {
                      cssClass:'btnAceptar',
                      text:'Ir a Inicio',
                      handler:()=>{
                        this.navCtrl.setRoot(DashboardPage)
                      }
                    }
                  ]
                }).present()
              },
              err => {
                console.log(err)
                this.alertCrtl.create({
                  title:'Atención',
                  subTitle:'Ha ocrrido un error',
                  buttons:[{
                    cssClass:'btnAceptar',
                    text:'Aceptar'
                  }]
                }).present()
                this.DesactivarLoading()
              }
            )
          }
        } else {
          this.alertCrtl.create({
            title:'Atención',
            subTitle:'Debe ingresar todos los campos correspondientes.',
            buttons:[{
              cssClass:'btnAceptar',
              text:'Aceptar'
            }]
          }).present()
      }
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  close(){
    this.navCtrl.pop()
  }

}



// WEBPACK FOOTER //
// ./src/pages/cobro/cobro.ts